import { apiClient } from "./config";

/**
 * Get list templates plans content preset import configurations
 * @param param0
 * @param param0.params
 * @param param0.options
 * @param successCallback
 * @param errorCallback
 * @returns {Promise<*>}
 */
export const getListTemplatesPlansContentPresetImportConfigurations = async (
	{ params, options },
	successCallback = false,
	errorCallback = false
) => {
	const { templatePlan, contentPreset, ...body } = params;

	try {
		const response = await apiClient.get(
			`/admin/templates/plans/${templatePlan}/content-presets/${contentPreset}/import-configurations`,
			{ params: body, ...options }
		);
		if (successCallback) successCallback(response.data);
		return response.data;
	} catch (error) {
		if (errorCallback) errorCallback(error.response);
		return error;
	}
};

/**
 * Create new templates plans content preset import configuration
 * @param {title, selection_mode, templatePlan, contentPreset} body
 * @param {function} successCallback
 * @param {function} errorCallback
 * @returns
 */
export const createTemplatesPlansContentPresetImportConfiguration = async (
	body,
	successCallback = false,
	errorCallback = false
) => {
	const { templatePlan, contentPreset, ...data } = body;

	try {
		const response = await apiClient.post(
			`/admin/templates/plans/${templatePlan}/content-presets/${contentPreset}/import-configurations`,
			data
		);
		if (successCallback) successCallback(response.data);
		return response.data;
	} catch (error) {
		if (errorCallback) errorCallback(error.response);
		return error;
	}
};

/**
 * Get templates plans content preset import configuration
 * @param {templatePlan, contentPreset, importConfiguration} params
 * @param successCallback
 * @param errorCallback
 * @returns {Promise<*>}
 */
export const getTemplatesPlansContentPresetImportConfiguration = async (
	params,
	successCallback = false,
	errorCallback = false
) => {
	const { templatePlan, contentPreset, importConfiguration, ...body } = params;

	try {
		const response = await apiClient.get(
			`/admin/templates/plans/${templatePlan}/content-presets/${contentPreset}/import-configurations/${importConfiguration}`,
			{ params: body }
		);
		if (successCallback) successCallback(response.data);
		return response.data;
	} catch (error) {
		if (errorCallback) errorCallback(error.response);
		return error;
	}
};

/**
 * Edit templates plans content preset import configuration
 * @param {title, selection_mode, lock_version, templatePlan, contentPreset, importConfiguration} body
 * @param {function} successCallback
 * @param {function} errorCallback
 * @returns
 */
export const editTemplatesPlansContentPresetImportConfiguration = async (
	body,
	successCallback = false,
	errorCallback = false
) => {
	const { templatePlan, contentPreset, importConfiguration, ...data } = body;

	try {
		const response = await apiClient.patch(
			`/admin/templates/plans/${templatePlan}/content-presets/${contentPreset}/import-configurations/${importConfiguration}`,
			data
		);
		if (successCallback) successCallback(response.data);
		return response.data;
	} catch (error) {
		if (errorCallback) errorCallback(error.response);
		return error;
	}
};

/**
 * Delete templates plans content preset import configuration
 * @param {templatePlan, contentPreset, importConfiguration} params
 * @param {function} successCallback
 * @param {function} errorCallback
 * @returns
 */
export const deleteTemplatesPlansContentPresetImportConfiguration = async (
	params,
	successCallback = false,
	errorCallback = false
) => {
	const { templatePlan, contentPreset, importConfiguration } = params;
	try {
		const response = await apiClient.delete(
			`/admin/templates/plans/${templatePlan}/content-presets/${contentPreset}/import-configurations/${importConfiguration}`
		);
		if (successCallback) successCallback(response.data);
		return response.data;
	} catch (error) {
		if (errorCallback) errorCallback(error.response);
		return error;
	}
};

/**
 * Get templates plans content preset tree
 * @param {templatePlan, contentPreset, configuration_id} params
 * @param successCallback
 * @param errorCallback
 * @returns {Promise<*>}
 */
export const getTemplatesPlansContentPresetTree = async (
	params,
	successCallback = false,
	errorCallback = false
) => {
	const { templatePlan, contentPreset, ...body } = params;

	try {
		const response = await apiClient.get(
			`/admin/templates/plans/${templatePlan}/content-presets/${contentPreset}/tree`,
			{ params: body }
		);
		if (successCallback) successCallback(response.data);
		return response.data;
	} catch (error) {
		if (errorCallback) errorCallback(error.response);
		return error;
	}
};

/**
 * Apply templates plans content preset import configuration
 * @param {templatePlan, contentPreset, importConfiguration} params
 * @param successCallback
 * @param errorCallback
 * @returns {Promise<*>}
 */
export const applyTemplatesPlansContentPresetImportConfiguration = async (
	params,
	successCallback = false,
	errorCallback = false
) => {
	const { templatePlan, contentPreset, ...body } = params;

	try {
		const response = await apiClient.post(
			`/admin/templates/plans/${templatePlan}/content-presets/${contentPreset}/apply`,
			body
		);
		if (successCallback) successCallback(response.data);
		return response.data;
	} catch (error) {
		if (errorCallback) errorCallback(error.response);
		return error;
	}
};
